module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMABO+s5jQz97KUiHdHPRn5et6hQQBdAAAAv0lEQVRIx+3Vyw6CMBSE4SJHrC0UnPd/WGVBJm3Sabpo3DA7kv/zEpOjuzd0mzdUZ34r+wONHcXrY4/JVZfijvw9PKKTi/DZsyFpkGDZMyBiFv8AUzALUwcIABA6gJ3ABoDqR1rmtetLPx94rXXAsf9cQgL28/T+iTZg79wp2oD9JTRgfwkN2FNIwJ5CAvYUErCnEKDsm7/0wl4B0QvAvg1ELwD7FjAk9vqQ8VSy16eSx5i9OMYd5773D+XeyH0BZGQXEsPWR90AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_image.png
// module id = 240
// module chunks = 1